import { DimensionsOptions } from "@lvt/streaming";
import { createContext, PropsWithChildren, useCallback, useEffect, useRef, useState } from "react";

import useStyles from "@/common/components/liveUnitMosaic/Mosaic/MosaicItem/MosaicItem.styles";


export type BaseMosaicItem = { cameraId: number | string }

interface MosaicItemProps {
    nTiles: number;
}


export const MosaicItemDimensionsContext = createContext<DimensionsOptions>({});

const MosaicItem = ({ nTiles, children }: PropsWithChildren<MosaicItemProps>) => {
    const [height, setHeight] = useState(50);
    const [width, setWidth] = useState(50);
    const classes = useStyles();
    const refObserver = useRef<ResizeObserver>();
    const [dimensions, setDimensions] = useState<DimensionsOptions>({});

    useEffect(() => {
        if (nTiles <= 1) {
            setHeight(100);
            setWidth(100);
        } else if (nTiles <= 2) {
            setHeight(100 / 2);
            setWidth(100);
        } else if (nTiles <= 4) {
            setHeight(100 / 2);
            setWidth(100 / 2);
        } else if (nTiles <= 6) {
            setHeight(100 / 2);
            setWidth(100 / 3);
        } else if (nTiles <= 9) {
            setHeight(100 / 3);
            setWidth(100 / 3);
        } else if (nTiles <= 12) {
            setHeight(100 / 3);
            setWidth(100 / 4);
        } else if (nTiles <= 16) {
            setHeight(100 / 4);
            setWidth(100 / 4);
        } else if (nTiles <= 20) {
            setHeight(100 / 4);
            setWidth(100 / 5);
        } else if (nTiles <= 25) {
            setHeight(100 / 5);
            setWidth(100 / 5);
        } else if (nTiles <= 30) {
            setHeight(100 / 6);
            setWidth(100 / 5);
        } else if (nTiles <= 36) {
            setHeight(100 / 6);
            setWidth(100 / 6);
        }
    }, [nTiles]);

    const refStreamContainerCb = useCallback((node: HTMLDivElement | null) => {
        if (refObserver.current) {
            refObserver.current.disconnect();
        }

        if (node) {
            const resize = () => {
                const streamBox = node?.getBoundingClientRect();

                setDimensions({ width: streamBox?.width, height: streamBox?.height });
            };

            refObserver.current = new ResizeObserver(resize);

            refObserver.current.observe(node);
            resize();
        }
    }, []);

    const margin = 1.5;

    return (
        <div ref={refStreamContainerCb} style={{ height: `calc(${height}% - ${2 * margin}px)`, width: `calc(${width}% - ${2 * margin}px)`, margin, overflow: "hidden", borderRadius: "0.5em" }}>
            <div className={classes.item}>
                <MosaicItemDimensionsContext.Provider value={dimensions}>
                    {children}
                </MosaicItemDimensionsContext.Provider>
            </div>
        </div>

    );
};

export default MosaicItem;
